module.exports = __webpack_public_path__ + "static/images/styles/images/nations/uk.fc2f1331.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/uk.png
// module id = 3674
// module chunks = 11